import { render, staticRenderFns } from "./topperformers.vue?vue&type=template&id=a12c894c&scoped=true&"
import script from "./topperformers.vue?vue&type=script&lang=js&"
export * from "./topperformers.vue?vue&type=script&lang=js&"
import style0 from "./topperformers.vue?vue&type=style&index=0&id=a12c894c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12c894c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
